"use client";
import { useEffect } from "react";

export function ViewTracker({ slug }: { slug: string }) {
  useEffect(() => {
    const key = `viewed_cs_${slug}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
    fetch(`/api/case-studies/${slug}/view`, { method: "POST" }).catch(() => {});
  }, [slug]);
  return null;
}
